module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: ['app-context-switcher-preview', _vm.active ? 'active' : null],
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "app-context-switcher-preview__inner"
  }, [_c('img', {
    attrs: {
      "src": require('../assets/context-switcher-mockup.svg')
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5143437a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSwitcherPreview.vue
// module id = 445
// module chunks = 1